import { FormProvider, useForm } from "react-hook-form";
import { FiX } from "react-icons/fi";
import { toast } from "react-hot-toast";
import { GetSearchParams } from "../../../../../../utils/functions/ResourceFunctions";
import { useCreateScoreRecommendationMutation } from "../../../../../api/hrApi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons } from "../../../../../global/components/Buttons/buttons";
import {
  FormInput,
  FormSelect,
  FormTemplate,
  FormTextArea,
} from "../../../../Components/Forms/InputTemplate";
const ScoreBaseModal = ({
  isOpen,
  setIsOpen,
  isLoading,
  // refresh,
  // setRefresh,
  onValidate = () => { },
}) => {
  const [onCreate] = useCreateScoreRecommendationMutation();
  const defaultData = {
    title: GetSearchParams("title"),
    description: GetSearchParams("des"),
  };
  const formMethods = useForm({
    defaultValues: defaultData,
    mode: "all",
  });
  const {
    handleSubmit,
    formState: { isValid },
  } = formMethods;

  const submit = async (data) => {
    const payload = {
      employeeType: parseInt(data?.employeeType),
      recommendationTitle: data.recommendationTitle,
      fromScore: parseInt(data.fromScore),
      toScore: parseInt(data.toScore),
      recommendationDescription: data.recommendationDescription,
    };
    try {
      const response = await onCreate(payload).unwrap();
      if (response?.successful) {
        setIsOpen(false);
        onValidate();
        toast.success(response?.statusMessage);
      }
    } catch (err) {
      toast.error(err?.data?.statusMessage);
    }
  };

  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_header}>
        <div>
          <h4 className="text-[25px] font-[500]">Set Up </h4>
          <h1 className="text-[28px] font-[800]">Score Base Recommendation</h1>
          <p>
            Helps the system suggest appropriate actions based on performances
            score
          </p>
        </div>
        <FiX
          style={{ cursor: "pointer" }}
          size={"1.5rem"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        {isLoading && <small>Loading...</small>}
        <div>
          <FormProvider {...formMethods}>
            <FormTemplate handleSubmit={handleSubmit(submit)}>
              <FormSelect
                title={"Employee Type"}
                camelCase={"employeeType"}
                defaultValue={''}
                array={[{
                  label: "New", value: 1
                }, { label: "Existing", value: 2 }]?.map(dat => <option value={dat?.value} key={dat.value}>{dat?.label}</option>)}
              />
              <FormInput
                title={"Recommendation Title"}
                camelCase={"recommendationTitle"}
                placeholder={"select"}
              />
              <FormInput
                title={"Minimum"}
                camelCase={"fromScore"}
                placeholder={"select"}
              />
              <FormInput
                title={"Maximum"}
                camelCase={"toScore"}
                placeholder={"select"}
              />
              <FormTextArea
                className="h-[200px]"
                title={"Recommendation Description"}
                camelCase={"recommendationDescription"}
              />
              <div
                style={{ marginTop: "1rem" }}
                className={DashboardStyle.button_cage}
              >
                <ActionButtons
                  isLoading={isLoading}
                  disabled={!isValid}
                  width={"auto"}
                  type={"submit"}
                  className={DashboardStyle?.button_cage_weight}
                  bg="var(--primary-color)"
                >
                  Create Recommendation
                </ActionButtons>
              </div>
            </FormTemplate>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default ScoreBaseModal;
